export const bindListeners = (context, names) => {
  names.forEach((name) => {
    const self = context;
    if (context[name]) {
      self[name] = context[name].bind(context);
    } else {
      throw new Error(`Nothing to bind for ${name}.`);
    }
  });
};

export const joinClass = (...classes) => classes.reduce((list, name) => {
  if (name) {
    list.push(name);
  }
  return list;
}, []).join(' ');
